<template>
  <div>
    <GeneralInformationMeterRecord></GeneralInformationMeterRecord>
    <RecordsListMeterUnit></RecordsListMeterUnit>
  </div>
</template>

<script>
import GeneralInformationMeterRecord from "./GeneralInformationMeterRecord";
import RecordsListMeterUnit from "../meter-units/RecordsListMeterUnit";

export default {
  name: "MeterRecord",
  components: {
    RecordsListMeterUnit,
    GeneralInformationMeterRecord
  }
};
</script>

<style scoped>
div >>> .common-table-container {
  height: calc(100vh - 270px - 120px);
}
</style>
